export const generateUniqueId = () => `${Date.now() + Math.random()}`